import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as store from 'store';

import TestSelectionComponent from './Component';

class TestSelectionContainer extends React.PureComponent {
  get value () {
    return this.props.parameterType === 'categorical'
      ? 'proportion'
      : 'mean';
  }

  get text () {
    return this.props.parameterType === 'categorical'
      ? 'Proportion'
      : 'Mean';
  }

  get options () {
    return [
      {
        value: this.value,
        text: this.text
      }
    ];
  }

  render () {
    const { parameterType, ...props } = this.props // eslint-disable-line

    return (
      <TestSelectionComponent
        options={this.options}
        value={this.value}
        {...props}
      />
    );
  }
}

TestSelectionContainer.propTypes = {
  parameterType: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  parameterType: store.form.samplingDistributions.getParameterType(state)
});

export default connect(mapStateToProps)(TestSelectionContainer);
